import { History } from 'history';

/**
 * Ideally the `history` package would expose a base class we could use as a reference, but they only expose a TS interface.
 *
 * This class allows us to expose a class we can use in IOC while leveraging the interface exposed by the `history` package.
 *
 * see ioc.ts where we use register an "instance" of AppHistory from the `history` package.
 *
 */
export class AppHistory implements History {
  length: number; action: import('history').Action;
  location: import('history').Location<any>;
  push(path: string, state?: any): void;
  push(location: import('history').LocationDescriptorObject<any>): void;
  push(path: any, state?: any) {
    throw new Error('Method not implemented.');
  }
  replace(path: string, state?: any): void;
  replace(location: import('history').LocationDescriptorObject<any>): void;
  replace(path: any, state?: any) {
    throw new Error('Method not implemented.');
  }
  go(n: number): void {
    throw new Error('Method not implemented.');
  }
  goBack(): void {
    throw new Error('Method not implemented.');
  }
  goForward(): void {
    throw new Error('Method not implemented.');
  }
  block(prompt?: string | boolean | History.TransitionPromptHook): import('history').UnregisterCallback {
    throw new Error('Method not implemented.');
  }
  listen(listener: History.LocationListener): import('history').UnregisterCallback {
    throw new Error('Method not implemented.');
  }
  createHref(location: import('history').LocationDescriptorObject<any>): string {
    throw new Error('Method not implemented.');
  }
}



// WEBPACK FOOTER //
// ./src/framework/AppHistory.ts